<template>
  <o-view :no-scroll="true">
    <o-nav-bar title="Cambio" :has-back-button="true" />
    <o-block-list title="Kies uw budget">
      <o-list-item
        icon="home"
        label="Privé"
        link="/sales/car/cambio/reservations"
        label-right="Cambio actief"
      />
      <o-list-item
        icon="work"
        label="Werk"
        link="/sales/car/cambio/onboarding/mobib"
        label-right="Cambio niet actief"
      />
    </o-block-list>
  </o-view>
</template>

<script>
import OListItem from '@/components/base/OListItem.vue'
export default {
  name: 'CambioBudget',
  components: { OListItem }
}
</script>
